import React, { FunctionComponent, useState, useEffect } from 'react';
import {
  useGetBackofficeDocumentLeadsQuery,
  useGetBackofficeDocumentLeadsCSVQuery,
} from 'services/exploreApi';
import { navigateTop } from 'common/utils/index';
import Index from '../Index';
import SearchBar from '../SearchBar';
import styles from './DocumentLeads.module.scss';

interface Pagination {
  pages: number;
  current: number;
  total: number;
}

const defaultPage: Pagination = {
  pages: 0,
  current: 0,
  total: 0,
};

const DocumentLeads: FunctionComponent = () => {
  const [searchFilters, setSearchFilters] = useState<{ [k: string]: any }>({});
  const [pagination, setPagination] = useState<Pagination>(defaultPage);
  const { data: documentLeadsCSV } = useGetBackofficeDocumentLeadsCSVQuery({
    ...searchFilters,
  });
  const { data: documentLeads, isLoading: documentLeadsLoading } =
    useGetBackofficeDocumentLeadsQuery({
      ...searchFilters,
      page: pagination.current,
    });

  const onFilterChange = (key: string, value: any) => {
    if (value === undefined || value === null || value === '') {
      setSearchFilters(({ [key]: _, ...rest }) => rest);
    } else {
      setSearchFilters((sf) => ({ ...sf, [key]: value }));
    }
  };

  const onFilterTextInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.trimStart();
    onFilterChange(key, event.target.value);
  };

  const changePageDocumentLeads = (page: number) => {
    setPagination((pp) => ({ ...pp, current: page }));
    navigateTop();
  };
  useEffect(() => {
    if (documentLeads?.meta) setPagination(documentLeads.meta);
  }, [documentLeads]);

  const columns = [
    'ID',
    'Email',
    'Name',
    'CV',
    'Degree certificate',
    'English Proof',
    'Passport',
    'Technical test',
    'Transcripts',
    'Profile Completed',
    'Applications Amount',
  ];

  return (
    <div className={styles.documentLead}>
      <SearchBar
        searchFilters={searchFilters}
        onFilterTextInputChange={onFilterTextInputChange}
        name="Search for user..."
      />
      <Index
        objects={documentLeads?.data}
        isLoading={documentLeadsLoading}
        pagination={{ ...pagination, onChange: changePageDocumentLeads }}
        columns={columns}
        csv={documentLeadsCSV}
      />
    </div>
  );
};

export default DocumentLeads;
